import {LoggedRoute} from './../logged-route'
import {
  AddCoursePageHandler,
  ArchivedRostersHandler,
  EditCoursePageHandler,
  LoginCardHandler,
  RosterStudentEditPageHandler,
  RostersHandler,
} from './lazy'

export const routerV2Roster = [
  {path: '/rosters', element: <LoggedRoute component={RostersHandler} />},
  {path: '/rosters/create', element: <LoggedRoute component={AddCoursePageHandler} />},
  {
    path: '/rosters/edit',
    element: <LoggedRoute component={EditCoursePageHandler} />,
  },
  {path: '/rosters/archived-roster', element: <LoggedRoute component={ArchivedRostersHandler} />},
  {path: '/rosters/login-cards', element: <LoggedRoute component={LoginCardHandler} />},
  {
    path: '/students/:studentId/edit',
    element: <LoggedRoute component={RosterStudentEditPageHandler} />,
  },
]
